
export const CREATE_COURSE_INSTANCE = "CREATE_COURSE_INSTANCE";
export const SET_COURSE_INSTANCE = "SET_COURSE_INSTANCE";
export const CREATE_COURSE_INSTANCE_ERROR = "CREATE_COURSE_INSTANCE_ERROR";
export const UPDATE_COURSE_INSTANCE = "UPDATE_COURSE_INSTANCE";
export const UPDATE_COURSE_INSTANCE_SUCCESS = "UPDATE_COURSE_INSTANCE_SUCCESS";
export const UPDATE_COURSE_INSTANCE_ERROR = "UPDATE_COURSE_INSTANCE_ERROR";
export const CLEAR_COURSE_INSTANCE_ERRORS = "CLEAR_COURSE_INSTANCE_ERRORS";
export const CLEAR_COURSE_INSTANCE_STATE = "CLEAR_COURSE_INSTANCE_STATE";

export const createCourseInstance = (payload: any) => ({
  type: CREATE_COURSE_INSTANCE,
  payload,
});

export const setCourseInstance = (payload: any) => ({
  type: SET_COURSE_INSTANCE,
  payload,
});

export const updateCourseInstance = (payload: any) => ({
  type: UPDATE_COURSE_INSTANCE,
  payload,
});

export const updateCourseInstanceSuccess = (payload: any) => ({
  type: UPDATE_COURSE_INSTANCE_SUCCESS,
  payload,
});

export const createCourseInstanceError = (payload: any) => ({
  type: CREATE_COURSE_INSTANCE_ERROR,
  payload,
});

export const updateCourseInstanceError = (payload: any) => ({
  type: UPDATE_COURSE_INSTANCE_ERROR,
  payload,
});

export const clearCourseInstanceErrors = () => ({
  type: CLEAR_COURSE_INSTANCE_ERRORS,
});

export const clearCourseInstanceState = () => ({
  type: CLEAR_COURSE_INSTANCE_STATE,
});

